import ApiService from '~/utils/ApiService';
import * as agentActions from '~/actions/agents';

export const ADD_TEAM_TO_NAV = 'ADD_TEAM_TO_NAV';
export const COLLAPSE_EXPLORE_MENU = 'COLLAPSE_EXPLORE_MENU';
export const COLLAPSE_TEAM_MENUS = 'COLLAPSE_TEAM_MENUS';
export const EXPAND_SEARCH_BAR = 'EXPAND_SEARCH_BAR';
export const TOGGLE_EXPLORE_MENU = 'TOGGLE_EXPLORE_MENU';
export const TOGGLE_RESEARCH_MENU = 'TOGGLE_RESEARCH_MENU';
export const TOGGLE_SETTINGS_DROPDOWN = 'TOGGLE_SETTINGS_DROPDOWN';
export const TOGGLE_SUB_OPTION = 'TOGGLE_SUB_OPTION';
export const UPDATE_ACTIVE_STATE_AND_PARAMS = 'UPDATE_ACTIVE_STATE_AND_PARAMS';
export const UPDATE_ACTIVE_TEAM = 'UPDATE_ACTIVE_TEAM';
export const UPDATE_ACTIVE_TEAM_PARENT = 'UPDATE_ACTIVE_TEAM_PARENT';
export const UPDATE_TEAM_REPORTS = 'UPDATE_TEAM_REPORTS';
export const UPDATE_USER_AUTH = 'UPDATE_USER_AUTH';
export const UPDATE_ACTIVE_TOUR_TAB = 'UPDATE_ACTIVE_TOUR_TAB';
export const TOGGLE_RESOURCES_DROPDOWN = 'TOGGLE_RESOURCES_DROPDOWN';
export const CLOSE_RESOURCES_DROPDOWN = 'CLOSE_RESOURCES_DROPDOWN';
export const UPDATE_NEWSLETTER_VALIDITY = 'UPDATE_NEWSLETTER_VALIDITY';
export const REQUEST_NEWSLETTER_SIGNUP = 'REQUEST_NEWSLETTER_SIGNUP';
export const RECEIVE_NEWSLETTER_SIGNUP_SUCCESS = 'RECEIVE_NEWSLETTER_SIGNUP_SUCCESS';
export const UPDATE_NEWSLETTER_SIGNUP_ERROR = 'UPDATE_NEWSLETTER_SIGNUP_ERROR';
export const RESET_NEWSLETTER_FORM = 'RESET_NEWSLETTER_FORM';

export const updateActiveTourTab = tab => {
  return {
    type: UPDATE_ACTIVE_TOUR_TAB,
    tab,
  };
};

export const expandSearchBar = bool => {
  return {
    type: EXPAND_SEARCH_BAR,
    bool,
  };
};

export const collapseExploreMenu = () => {
  return {
    type: COLLAPSE_EXPLORE_MENU,
  };
};

export const collapseTeamMenus = () => {
  return {
    type: COLLAPSE_TEAM_MENUS,
  };
};

export const toggleActiveTeam = team => {
  return {
    type: UPDATE_ACTIVE_TEAM,
    team: team,
  };
};

export const toggleExploreMenu = () => {
  return {
    type: TOGGLE_EXPLORE_MENU,
  };
};

export const toggleSubOption = (teamId, option) => {
  return {
    type: TOGGLE_SUB_OPTION,
    teamId: teamId,
    option: option,
    snowplow: true,
  };
};

export const updateActiveStateAndParams = (activeState, activeParams) => {
  return {
    type: UPDATE_ACTIVE_STATE_AND_PARAMS,
    activeState,
    activeParams,
  };
};

export const updateActiveTeamParent = teamId => {
  return {
    type: UPDATE_ACTIVE_TEAM_PARENT,
    teamId,
    snowplow: true,
  };
};

export const updateActiveTeam = teamId => {
  return function(dispatch, getState) {
    const teamState = getState().teamState;
    const navigationState = getState().navigationState;
    const teamToMakeActive = teamState.teams.filter(function(team) {
      return team.id === teamId;
    })[0];

    // we're fetching agents/reports every time the user toggles a team on the nav
    // but we don't need to do it when a user is "closing" a team, only "opening"
    if (navigationState.activeParams.teamId !== teamId) {
      dispatch(agentActions.fetchAgents(teamToMakeActive));
    }
    return dispatch(toggleActiveTeam(teamToMakeActive));
  };
};

export const updateTopLevelOptions = teamId => {
  if (teamId) {
    // toggling a team, so close the explore menu and handle the team toggle
    return function(dispatch) {
      dispatch(collapseExploreMenu());
      return dispatch(updateActiveTeam(teamId));
    };
  } else {
    // toggling the explore menu, so close teams and handle the explore toggle
    return function(dispatch) {
      dispatch(collapseTeamMenus());
      return dispatch(toggleExploreMenu());
    };
  }
};

export const createNewTeam = name => {
  return function(dispatch) {
    return ApiService.post('/teams', name).then(function(res) {
      return dispatch(addTeamToNav(res));
    });
  };
};

export const addTeamToNav = team => {
  return {
    type: ADD_TEAM_TO_NAV,
    team,
  };
};

export const checkUserAuth = () => {
  return function(dispatch, getState) {
    const isLoggedIn = getState().myState.isLoggedIn;
    return {
      type: UPDATE_USER_AUTH,
      isLoggedIn,
    };
  };
};

export const toggleSettingsDropdown = () => {
  return {
    type: TOGGLE_SETTINGS_DROPDOWN,
  };
};

export const toggleResourcesDropdown = () => {
  return {
    type: TOGGLE_RESOURCES_DROPDOWN,
  };
};

export const closeResourcesDropdown = () => {
  return {
    type: CLOSE_RESOURCES_DROPDOWN,
  };
};

export const updateNewsletterValidity = bool => {
  return {
    type: UPDATE_NEWSLETTER_VALIDITY,
    bool,
  };
};

export const requestNewsletterSignup = () => {
  return {
    type: REQUEST_NEWSLETTER_SIGNUP,
  };
};

export const receiveNewsletterSignupSuccess = () => {
  return {
    type: RECEIVE_NEWSLETTER_SIGNUP_SUCCESS,
    snowplow: true,
  };
};

export const receiveNewsletterSignupError = error => {
  return {
    type: UPDATE_NEWSLETTER_SIGNUP_ERROR,
    snowplow: true,
    error,
  };
};

export const submitNewsletterSignup = email => {
  return function(dispatch) {
    dispatch(requestNewsletterSignup());

    ApiService.post('/newsletter/signup', { data: { email: email } })
      .then(() => {
        dispatch(receiveNewsletterSignupSuccess());
        // analytics.track('signup', {
        //   category: 'Newsletter',
        //   label: ''
        // });
      })
      .catch(err => {
        dispatch(receiveNewsletterSignupError(err.message));
      });
  };
};

export const resetNewsletterForm = () => {
  return {
    type: RESET_NEWSLETTER_FORM,
  };
};
